import { useSearchParams } from 'next/navigation';
import { NavigationItemData } from '../../../../../packages/ui/components/navigation/navigation';
import { useNavigation } from '../../../../../packages/ui/components/navigation';
import { useEffect } from 'react';

export const useNavigationWithSearchParam = (
  menuItems: NavigationItemData[],
  searchKey: string
) => {
  const searchParams = useSearchParams();
  const defaultItemId = searchParams.get(searchKey);
  const { activeId, handleItemClick, lockedActiveId } =
    useNavigation(menuItems);

  useEffect(() => {
    if (defaultItemId) {
      const defaultItem = menuItems.find((item) => item.id === defaultItemId);
      if (!defaultItem) return;
      handleItemClick(defaultItem);
      const nextParams = new URLSearchParams(searchParams);
      nextParams.delete(searchKey);
      history.replaceState(null, '', `?${nextParams.toString()}`);
    }
  }, [defaultItemId]);

  return {
    activeId,
    handleItemClick,
    lockedActiveId,
  };
};
